import {
   DatePicker as MuiDatePicker,
   DatePickerProps as MuiDatePickerProps,
} from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import {dateFormatMoment, dateFormatMomentMask} from 'common/formats';
import React from 'react';
import {Dayjs} from 'dayjs';

export type DatePickerProps = Partial<MuiDatePickerProps<Dayjs, Dayjs>> & {
   name?: string;
   onChange: MuiDatePickerProps<Dayjs, Dayjs>['onChange'];
   value: MuiDatePickerProps<Dayjs, Dayjs>['value'];

   emptyValue?: string;
   yearOnly?: boolean;
   substrDate?: boolean;

   helperText?: string | boolean;
   error?: boolean;
};

const DatePicker = ({
   name,
   emptyValue = '',
   yearOnly,
   substrDate,
   helperText,
   error,
   ...restProps
}: DatePickerProps) => {
   const dateYearOnlyProps: Partial<DatePickerProps> = yearOnly
      ? {
           inputFormat: 'YYYY',
           views: ['year'],
        }
      : {};
   // console.debug('DatePicker', restProps.value, restProps.value || emptyValue, restProps);
   return (
      <MuiDatePicker
         // autoComplete="off"
         // autoOk

         name={name}
         inputFormat={dateFormatMoment}
         mask={dateFormatMomentMask}
         {...restProps}
         {...dateYearOnlyProps}
         renderInput={(props) => {
            // console.debug('DatePicker > TextField', props.value, props);
            return (
               <TextField
                  name={name}
                  fullWidth
                  {...props}
                  inputProps={{
                     ...props.inputProps,
                     value: props.inputProps?.value || emptyValue,
                  }}
                  error={error}
                  helperText={helperText}
               />
            );
         }}
      />
   );
};

export default DatePicker;
